import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, DestroyRef,
  ElementRef, EventEmitter,
  Input, OnChanges,
  OnDestroy,
  OnInit, Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {DmsNewsItem} from "../../../../model/dmsNewsItem";
import {DmsPossibleWfTaskResultsSchema} from "../../../../model/dmsPossibleWfTaskResultsSchema";
import {IncomingDataAttachments} from "../../../../shared/interfaces/shared/IncomingDataAttachments";
import {DmsNewsCommentItem} from "../../../../model/dmsNewsCommentItem";
import {DomSanitizer} from "@angular/platform-browser";
import {DmsMetadataSchema} from "../../../../model/dmsMetadataSchema";
import {DmsMfTorzsItemsByLeiro} from "../../../../model/dmsMfTorzsItemsByLeiro";
import {DmsDictItemsByType} from "../../../../model/dmsDictItemsByType";
import {DmsWfTaskResultItem} from "../../../../model/dmsWfTaskResultItem";
import {Subscription} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {DmsWfTasksService} from "../../../../services/api/dms-wf-tasks.service";
import {DmsTasksService} from "../../../../services/api/dms-tasks.service";
import {select, Store} from "@ngrx/store";
import {FormWorkflowState} from "../../../../store/states/formWorkflowState";
import {FormTaskState} from "../../../../store/states/formTaskState";
import {Router} from "@angular/router";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {selectSendContentById} from "../../../../store/selectors/form.selectors";
import {selectTaskSendContentById} from "../../../../store/selectors/formtask.selectors";
import {setSendContent} from "../../../../store/actions/form.actions";
import {setTaskSendContent} from "../../../../store/actions/formtask.actions";
import {DialogForwardBoxComponent} from "../../../shared/dialog-forward-box/dialog-forward-box.component";
// import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatButton, MatMiniFabButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
// import {MatInput} from "@angular/material/input";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {NgForOf, NgIf} from "@angular/common";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {DialogInfoComponent} from "../../../shared/dialog-info/dialog-info.component";
import {SharedModule} from "../../../../modules/shared/shared.module";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MetaDataWorkflowComponent} from "../../shared/metadata/meta-data-workflow/meta-data-workflow.component";
import {MetaDataSzotarAcComponent} from "../../shared/metadata/meta-data-szotar-ac/meta-data-szotar-ac.component";
import {MetaDataSzotarComponent} from "../../shared/metadata/meta-data-szotar/meta-data-szotar.component";
import {MetaDataSzervuserComponent} from "../../shared/metadata/meta-data-szervuser/meta-data-szervuser.component";
import {
  MetaDataSzervuserAcComponent
} from "../../shared/metadata/meta-data-szervuser-ac/meta-data-szervuser-ac.component";
import {AttachmentBoxEmbeddedComponent} from "../attachment-box-embedded/attachment-box-embedded.component";
import {MessageBoxEmbeddedComponent} from "../message-box-embedded/message-box-embedded.component";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
// import {EscapeAwareCharCountPipe} from "../../../../pipes/escape-aware-char-count.pipe";
// import {EscapeAwareMaxLengthDirective} from "../../../../directives/escape-aware-max-length.directive";
import {DmsAdditionalExecutorsSchema} from "../../../../model/dmsAdditionalExecutorsSchema";
import {DialogMandatoryCommentBoxComponent} from 'src/app/components/shared/dialog-mandatory-comment-box/dialog-mandatory-comment-box.component';
import { DmsWorkflowDigraph } from 'src/app/services/api/dms-workflow-digraph';
import { PrevOpenedTaskService } from 'src/app/services/component/navigation/prev-opened-task.service';

export const tabIndexMap: { [key: string]: number } = {
  details: 0,
  attachments: 1,
  comments: 2
};

@Component({
  selector: 'app-details-sidenav',
  imports: [
    // CdkTextareaAutosize,
    MatFormField,
    MatIcon,
    // MatInput,
    MatLabel,
    MatMiniFabButton,
    MatOption,
    MatSelect,
    NgForOf,
    NgIf,
    TranslateModule,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    SharedModule,
    MatTabGroup,
    MatTab,
    MetaDataWorkflowComponent,
    MetaDataSzotarAcComponent,
    MetaDataSzotarComponent,
    MetaDataSzervuserComponent,
    MetaDataSzervuserAcComponent,
    AttachmentBoxEmbeddedComponent,
    MessageBoxEmbeddedComponent,
    MatButton,
    // EscapeAwareCharCountPipe,
    // EscapeAwareMaxLengthDirective
  ],
  templateUrl: './details-sidenav.component.html',
  styleUrl: './details-sidenav.component.scss',
  standalone: true
})
export class DetailsSidenavComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges{

  @ViewChild('resultInput') resultInputElement!: ElementRef<HTMLElement>; //comment for result

  @Input() type!: DmsNewsItem.TypeEnum;
  @Input() status!: string | null; //task típus esetén a felhasználóhoz tartozó státusz
  @Input() taskStatus!: string | null; //task típus esetén a task státusza
  @Input() subject!: string;
  @Input() taskStart!: string;
  @Input() taskStartUser!: string;
  @Input() taskName!: string;
  @Input() possibleResults!: DmsPossibleWfTaskResultsSchema | [];
  @Input() id!: number;
  @Input() referenceNumber!: string;
  @Input() attachments!: IncomingDataAttachments[];
  @Input() comments!: DmsNewsCommentItem[];
  @Input() wfDescription?: string;
  @Input() taskDescription!: string;
  @Input() metaItem?: Array<DmsMetadataSchema> = [];
  @Input() mfTorzsOptionList?: DmsMfTorzsItemsByLeiro[];
  @Input() dictionaryOptionList?: DmsDictItemsByType[];
  @Input() result!: string;
  @Input() icon!: string;
  @Input() templateName?: string;
  @Input() isDetailsPage?:boolean = false;

  @Input() deadline?: string;

  @Input() taskAvailableFrom?: string;
  @Input() taskInternalDeadline?: string;
  @Input() taskPriority?: string;
  @Input() taskPartnerName?: string;

  @Input() taskAdditionalExecutors?: DmsAdditionalExecutorsSchema;

  @Input() backdropClicked: boolean = false;

  @Input() tabIndex!: number; //for attachments and comments buttons on feed-card

  @Output() closeEvent = new EventEmitter<{
    refreshPage: boolean,
    itemType?: DmsNewsItem.TypeEnum,
    itemId?: number,
    selectedResult?: DmsWfTaskResultItem | undefined
  }>();

  @Output() detailsEvent = new EventEmitter<number>();

  @Output() metaItemChange = new EventEmitter<Array<DmsMetadataSchema>>();

  selectedResult!: DmsWfTaskResultItem | undefined;

  sendTaskResult!: string;

  sendComment: string =  '';

  tempMetadata: Array<DmsMetadataSchema> = [];

  private sendContentSubscription: Subscription | undefined;
  private sendTaskContentSubscription: Subscription | undefined;
  private langChangeSub!: Subscription;

  sendContents: { comment: string; metadata: Array<DmsMetadataSchema> } = {comment: '', metadata: []};
  sendTaskContents: { comment: string } = {comment: ''};
  hasPreSaveData: boolean = true;

  reqDataError = 'Kérjük töltse ki a kötelező mezőket küldés előtt!';
  reqResultError = 'Eredmény kitöltése kötelező!';
  reqTypeError= "Hiba a feladat típusában!";
  deadlineTooltip = '';

  year_t = "éve";
  day_t = "napja";
  week_t = "hete";
  month_t = "hónapja";
  hour_t = "órája";
  minute_t = "perce";
  and_t = "és";
  ago_t = "";
  since_t = "";
  formattedCreatedTime = "";

  isSmallScreen: boolean = false;

  needToRefreshData: boolean = false;

  taskDisplayedColumns: string[] = ['name', 'status', 'result'];

  year = "év";
  day = "nap";
  hour = "óra";
  minute = "perc";
  formattedDeadline = "";

  missedDeadline = "Lejárt!";
  closedText = 'Lezárva';
  draftText = 'Vázlat';

  constructor(
    public dialog: MatDialog,
    public workflowItemService: DmsWfTasksService,
    public taskItemService: DmsTasksService,
    private storeWorkflow: Store<{ form: FormWorkflowState }>,
    private storeTask: Store<{ formTask: FormTaskState }>,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private translateService: TranslateService,
    public sanitizer: DomSanitizer,
    private breakpointObserver: BreakpointObserver,
    private destroyRef: DestroyRef,
    private dmsWorkflowDigraph: DmsWorkflowDigraph,
    public prevOpenedTaskService: PrevOpenedTaskService
  ) {
  }

  ngOnInit() {

    this.updateMultilingualValues();
    this.langChangeSub = this.translateService.onLangChange.subscribe((_event: LangChangeEvent) => {
      this.updateMultilingualValues();
    });

    if(this.id && this.type === 'WfTask') {

      //default result setting - wf
      if(this.possibleResults){
        this.selectedResult = this.possibleResults?.find(result => result.isSelected) ?? undefined;
      }

      //preset value loading into sidenav -wf
      if(this.isActiveStatus()) {
        this.sendContentSubscription = this.storeWorkflow.pipe(
          select(selectSendContentById(this.id))
        ).subscribe((filteredContent) => {
          if (filteredContent) {
            this.sendContents = structuredClone(filteredContent as {
              comment: string;
              metadata: Array<DmsMetadataSchema>
            });

            this.sendComment = this.sendContents.comment;
            this.metaItem = this.sendContents.metadata;

            this.hasPreSaveData = true;
          }
        });
      }

    } else if(this.id && this.type === 'Task') {

      //preset value loading into sidenav -task
      if(this.isActiveStatus()) {
        this.sendTaskContentSubscription = this.storeTask.pipe(
          select(selectTaskSendContentById(this.id))
        ).subscribe((filteredContent) => {
          if (filteredContent) {
            this.sendTaskContents = structuredClone(filteredContent as {
              comment: string;
            });

            this.sendComment = this.sendTaskContents.comment;

            this.hasPreSaveData = true;
          }
        });
      }

    }
    //task and wf desc are put to different places
    this.breakpointObserver.observe([
      "(max-width: 768px)"
    ]).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: BreakpointState) => {
      this.isSmallScreen = result.breakpoints['(max-width: 768px)'];
      //this.cdr.detectChanges();
        if(this.isActiveStatus()) {
          this.metaItemChange.emit(this.metaItem ? this.metaItem : []);
        }
    })
    this.changeVisibilityIfTaskDone();
  }

  ngAfterViewInit(): void {
    if(this.isMandatoryComment()){
      this.triggerCommentValidator();
    }
  }

  ngOnDestroy() {

    if (this.sendContentSubscription) {
      this.sendContentSubscription.unsubscribe();
    }

    if(this.sendTaskContentSubscription) {
      this.sendTaskContentSubscription.unsubscribe();
    }

    if(this.isActiveStatus()) {
      if (this.id && this.metaItem && this.type === 'WfTask') {
        this.storeWorkflow.dispatch(setSendContent({
          id: this.id,
          sendContent: {
            comment: this.sendComment,
            metadata: this.metaItem
          }
        }));
      } else if (this.id && this.type === 'Task') {
        this.storeTask.dispatch(setTaskSendContent({
          id: this.id,
          sendTaskContent: {
            comment: this.sendComment,
          }
        }));
      }
    }

    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['backdropClicked'] && changes['backdropClicked'].currentValue === true) {
      this.closeDetails();
    }
  }


  completeTask(){
      if (this.selectedResult && this.selectedResult.id.length>0) {
        this.sendTaskResult = this.selectedResult.id;
        if(this.selectedResult.isCommentRequired){
          const dialogRef = this.dialog.open(DialogMandatoryCommentBoxComponent,  {
            autoFocus: false,
            closeOnNavigation: true,
            data: this.selectedResult.displayName
          });
          dialogRef.afterClosed().subscribe(result => {
          if(result&&result.length>0){
            this.sendComment = result;
            this.sendCompleteRequest();
          } else alert(this.reqDataError);
          });
        } else {
          this.sendCompleteRequest();
        }
      } else {
        alert(this.reqResultError);
      }
  }

  private sendCompleteRequest(){
    if(this.type=='WfTask') {
      this.sendWorkflowRequest();
    } else if(this.type=='Task') {
      this.sendTaskRequest();
    } else alert(this.reqTypeError);
  }

  private sendTaskRequest(){
    if(this.sendTaskResult==='1_elfogadva'){
      this.taskItemService.createDmsTaskAccept$(Number(this.id), this.sendComment).subscribe( () => {
        this.reloadPage();
      })
    } else if(this.sendTaskResult==='1_lezarva'){
      this.taskItemService.createDmsTaskComplete$(Number(this.id), this.sendComment).subscribe( () => {
        this.reloadPage();
      })
    } else if(this.sendTaskResult==='1_elutasitva'){
      this.taskItemService.createDmsTaskDeny$(Number(this.id), this.sendComment).subscribe( () => {
        this.reloadPage();
      })
    } else alert(this.reqResultError);
  }

  private sendWorkflowRequest(){
    //kötelező adatok és formátumok ellenőrzése
    if(this.metaItem && this.checkMandatoryDataFill() && this.checkMandatoryCommentFill()) {
      //metaadatok formátum alakítása
      this.tempMetadata = this.metaItem;
      let send_metadata: { code: string, value: string | number | null }[];
      send_metadata = this.tempMetadata.map(item =>
        ({
          code: item.code,
          value: item.type === 'Check' ? (item.value ? '1' : '0') : item.value
        })
      );
      send_metadata.forEach(item => {
        if (item.value == '') item.value = null;
      })
      const sendContent = {
        comment: this.sendComment,
        wfTaskResult: this.sendTaskResult,
        metadata: send_metadata.reduce<{ [key: string]: any }>(
          (acc, item) => {
            acc[item.code] = item.value;
            return acc;
          }, {})
      };
      const sendContentJson = JSON.stringify(sendContent, null, 2);
      this.workflowItemService.createDmsWfTaskComplete$(Number(this.id), sendContentJson).subscribe(() => {
        this.reloadPage();
      });
    } else alert(this.reqDataError);
  }

  openInFullscreen(){
    this.router.navigate([this.routeToInfo()]);
    this.prevOpenedTaskService.setPrevOpenedTaskId(this.id);
  }

  routeToInfo(){
    if(this.type === "WfTask"){
      return '/workflow/'+this.id;
    } else if(this.type === "Task") {
      return '/task/' + this.id;
    } else {
      alert(this.reqDataError);
      return null;
    }
  }

  onForwardTask() {
    this.dialog.open(DialogForwardBoxComponent, {
      data: {
        type: this.type,
        id: this.id,
        name: this.subject,
        subject: this.taskName,
      },
      autoFocus: false,
      closeOnNavigation: true
    })
  }

  isResult(){
    return this.selectedResult && this.selectedResult.id.length > 0;
  }

  private reloadPage(){
    this.router.navigate(['/pageloading']);
  }

  private checkMandatoryDataFill(): boolean {
    if (this.metaItem) {
      const alszamRegex = /^(?:([\p{L}\p{N} \w.!*_\/-]+)\/)?([0-9]+)-([0-9]+)\/((?:19|20)[0-9]{2})(?:\/([\p{L}\p{N} \w.!*_\/-]+))?$/u;
      const foszamRegex = /^(?:([\p{L}\p{N} \w.!*_\/-]+)\/)?([0-9]+)\/((?:19|20)[0-9]{2})(?:\/([\p{L}\p{N} \w.!*_\/-]+))?$/u;
      return !this.metaItem.some(item =>
        (item.visibility === 'MT_K' && (item.value === null || item.value === undefined || item.value === '')) ||
        (item.visibility === 'MT_K' && item.type === "Check" && !item.value) ||
        (item.visibility === 'MT_K' && item.type === "Alszam" && !alszamRegex.test(item.value)) ||
        (item.visibility === "MT_K" && item.type === "Foszam" && !foszamRegex.test(item.value))
      );
    }
    return true;
  }

  private checkMandatoryCommentFill(): boolean {
    if (this.isMandatoryComment()) {
      return this.sendComment.length > 0;
    }
    return true;
  }

  isActiveStatus(){
    if (this.isDraftStatus()) return false;
    return this.status === '1_elfogadva' ||
      this.status === '1_letrehozva' ||
      this.status === 'Elfogadva' ||
      this.status === 'Létrehozva' ||
      this.status === 'FA_U' ||
      this.status === 'Új';
  }

  isDraftStatus(){
    return this.type === 'Task' && this.taskStatus === 'Draft';
  }

  isMandatoryComment(){
    return !!(this.selectedResult && this.selectedResult.isCommentRequired);
  }

  triggerCommentValidator() {
    if (this.resultInputElement) {
      let commentElement: HTMLElement = this.resultInputElement.nativeElement;
      commentElement.click();
    }
  }

  setCommentState(){
    if(this.isMandatoryComment()) {
      setTimeout(() => {
        if (this.resultInputElement && this.resultInputElement.nativeElement) {
          this.resultInputElement.nativeElement.focus();
          this.resultInputElement.nativeElement.blur();
          this.resultInputElement.nativeElement.click();
        }
      }, 300);
    }
    this.triggerCommentValidator();
  }

  dateFormatting(timestamp: string | null, date?: boolean){
    if (timestamp && timestamp.length>1) {
      let dateArray = timestamp.split('T');
      dateArray[1] = dateArray[1].substring(0, 5);
      if (date) {
        return dateArray[0];
      } else {
        return dateArray.join(' ');
      }
    }
    else return '';
  }

  setDeadlineTooltip(deadline_t: string, noDeadline_t: string, received_t: string){
    if (this.deadline) {
        this.deadlineTooltip = deadline_t + ': ' + this.deadline;
    } else {
        this.deadlineTooltip = noDeadline_t;
    }
    if (this.taskStart) {
      this.deadlineTooltip += '\n' + received_t + ': ' + this.taskStart;
    }
  }

  getDescription(){
    if(this.type==='WfTask'){
      return this.wfDescription ? this.wfDescription : '-';
    } else {
      return this.taskDescription ? this.taskDescription : '-';
    }
  }

  updateMultilingualValues(){
    this.translateService.get('MISSED_DEADLINE').subscribe((translatedText: string) => {
      this.missedDeadline = translatedText;
    });
    this.translateService.get('CLOSED').subscribe((translatedText: string) => {
      this.closedText = translatedText;
    });
    this.translateService.get('DRAFT').subscribe((translatedText: string) => {
      this.draftText = translatedText;
    });
    this.translateService.get('FILL_REQUIRED_FIELDS').subscribe((translatedText: string) => {
      this.reqDataError = translatedText;
    });
    this.translateService.get('RESULT_SELECTION_REQUIRED').subscribe((translatedText: string) => {
      this.reqResultError = translatedText;
    });
    this.translateService.get('TASK_TYPE_ERROR').subscribe((translatedText: string) => {
      this.reqTypeError = translatedText;
    });
    this.translateService.get('PAST_YEAR').subscribe(t => this.year_t = t);
    this.translateService.get('PAST_MONTH').subscribe(t => this.month_t = t);
    this.translateService.get('PAST_WEEK').subscribe(t => this.week_t = t);
    this.translateService.get('PAST_DAY').subscribe(t => this.day_t = t);
    this.translateService.get('PAST_HOUR').subscribe(t => this.hour_t = t);
    this.translateService.get('PAST_MINUTE').subscribe(t => this.minute_t = t);
    this.translateService.get('AND').subscribe(t => this.and_t = t);
    this.translateService.get('AGO').subscribe(t => this.ago_t = t);
    this.translateService.get('SINCE').subscribe(t => this.since_t = t);
    this.translateService.get('YEAR').subscribe(t => this.year = t);
    this.translateService.get('DAY').subscribe(t => this.day = t);
    this.translateService.get('HOUR').subscribe(t => this.hour = t);
    this.translateService.get('MINUTE').subscribe(t => this.minute = t);

    let noDeadline_t = "Nincs határidő!";
    let deadline_t = "Határidő";
    let received_t = "Kaptam";
    this.translateService.get('NO_DEADLINE').subscribe((translatedText: string) => {
      noDeadline_t = translatedText;
    });
    this.translateService.get('DEADLINE').subscribe((translatedText: string) => {
      deadline_t = translatedText;
    });
    this.translateService.get('RECEIVED').subscribe((translatedText: string) => {
      received_t = translatedText;
    });
    this.setDeadlineTooltip(deadline_t, noDeadline_t, received_t);
    this.formattedCreatedTime = this.getTimeSince(this.taskStart);
    this.formattedDeadline = this.getTimeLeft(this.deadline);
  }

  closeDetails(){ //refresh nem működik
    if(this.selectedResult) {
      this.closeEvent.emit({
        refreshPage: this.needToRefreshData,
        itemType: this.type,
        itemId: this.id,
        selectedResult: this.selectedResult
      });
    } else {
      this.closeEvent.emit({refreshPage: this.needToRefreshData});
    }
  }

  getTaskDesc(){ //not tooltip due to task desc being html text
    this.dialog.open(DialogInfoComponent, {
      data: {
        title: '',
        value: '',
        htmlValue: this.taskDescription || this.translateService.instant('NO_DESCRIPTION')
      },
      autoFocus: false,
    })
  }

  getTimeSince(created: string | undefined): string {
    if(created) {
      const currentTime = new Date();
      const createdTime = new Date(created);
      const timeDifference = currentTime.getTime() -createdTime.getTime();

      if (timeDifference <= 0) {
        return "";
      }

      const minutes = Math.floor(timeDifference / (1000 * 60));
      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const years = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 365));

      if (years >= 1) {
        return this.since_t + ' ' + years + ' ' + this.year_t + ' ' + this.ago_t;
      } else if (days >= 1) {
        const remainingTime = this.monthsDifferenceWithRemainingDays(currentTime, createdTime);
        const timeComponents = [];
        if (remainingTime.months > 0) {
          let timeComponentsMonthText = remainingTime.months + ' ' + this.month_t;
          if(remainingTime.days>0){
            if(remainingTime.weeks>0) {
              timeComponentsMonthText = timeComponentsMonthText + ',';
            } else {
              timeComponentsMonthText = timeComponentsMonthText + ' ' + this.and_t;
            }
          }
          timeComponents.push(timeComponentsMonthText);
        }
        if (remainingTime.weeks > 0) {
          let timeComponentsWeekText = remainingTime.weeks + ' ' + this.week_t;
          if(remainingTime.days>0){
            timeComponentsWeekText = timeComponentsWeekText + ' ' + this.and_t;
          }
          timeComponents.push(timeComponentsWeekText);
        }
        if (remainingTime.days > 0) {
          timeComponents.push(remainingTime.days + ' ' + this.day_t);
        }
        return this.since_t + ' ' + timeComponents.join(' ') + ' ' + this.ago_t;
      } else if (hours >= 1) {
        return this.since_t + ' ' + hours + ' ' + this.hour_t + ' ' + this.ago_t;
      } else {
        return this.since_t + ' ' + minutes + ' ' + this.minute_t + ' ' + this.ago_t;
      }
    } else return ""
  }

  private monthsDifferenceWithRemainingDays(current: any, past: any) {

    const currentDate = new Date(Date.UTC(current.getFullYear(), current.getMonth(), current.getDate()));
    const pastDate = new Date(Date.UTC(past.getFullYear(), past.getMonth(), past.getDate()));

    let months = (currentDate.getFullYear() - pastDate.getFullYear()) * 12 + (currentDate.getMonth() - pastDate.getMonth());

    if (currentDate.getDate() < pastDate.getDate()) {
      months--;
    }

    const tempDate = new Date(pastDate);
    tempDate.setMonth(tempDate.getMonth() + months);

    let remainingDays = Math.floor((currentDate.getTime() - tempDate.getTime()) / (1000 * 60 * 60 * 24));

    const remainingWeeks = Math.floor(remainingDays / 7);
    remainingDays = remainingDays - (remainingWeeks * 7);

    return { months: months, weeks: remainingWeeks, days: remainingDays };
  }

  trustHtml(textToHtml: string | undefined, sanitizer: DomSanitizer) {
    if (textToHtml) {
      let htmlText = this.htmlListFormatting(textToHtml);
      return sanitizer.bypassSecurityTrustHtml(htmlText);
    } else {
      return "";
    }
  }

  private htmlListFormatting(htmlString: string){
    let result = htmlString.replaceAll('<ol', '<ul');
    result = result.replaceAll('</ol', '</ul');
    return result;
  }

  refreshData(){
    this.needToRefreshData = true;
  }

  callDetailsEvent(){
    this.detailsEvent.emit(this.id);
  }

  private changeVisibilityIfTaskDone(){
    if(!this.isActiveStatus()&&this.metaItem && this.metaItem.length>0){
      this.metaItem.forEach(item=>{
        item.visibility = 'MT_O';
      })
    }
  }

  getTaskDetails(){
    return [
      {
        label: this.translateService.instant('AVAILABLE_FROM'),
        value: this.taskStart ? this.taskStart : '-'
      },
      {
        label: this.translateService.instant('INTERNAL_DEADLINE'),
        value: this.taskInternalDeadline ? this.dateFormatting(this.taskInternalDeadline, false) : '-'
      },
      {
        label: this.translateService.instant('TASK_STATUS'),
        value: this.taskStatus ? this.taskStatus : '-'
      },
      {
        label: this.translateService.instant('INTERNAL_STATUS'),
        value: this.isDetailsPage ? this.status : ( this.status ? this.statusFormatting(this.status) : '-' )
      },
      {
        label: this.translateService.instant('SERIAL_NUMBER'),
        value: this.referenceNumber ? this.referenceNumber : '-'
      },
      {
        label: this.translateService.instant('PRIORITY'),
        value: this.taskPriority ? this.taskPriority : '-'
      },
      {
        label: this.translateService.instant('PARTNER'),
        value: this.taskPartnerName ? this.taskPartnerName : '-'
      }
    ]
  }

  statusFormatting(status: string){
    switch (status) {
      case '1_letrehozva': {
        status = this.translateService.instant('STATUS_CREATED');
        break;
      }
      case '1_elfogadva': {
        status = this.translateService.instant('ACCEPTED');
        break;
      }
      case '1_elutasitva': {
        status = this.translateService.instant('REJECTED');
        break;
      }
      case '1_lezarva': {
        status = this.translateService.instant('CLOSED');
        break;
      }
      case '1_atiranyitva': {
        status = this.translateService.instant('STATUS_REDIRECTED');
        break;
      }
      case '1_megszunt': {
        status = this.translateService.instant('STATUS_TERMINATED');
        break;
      }
      case '1_sztornozott': {
        status = this.translateService.instant('STATUS_CANCELLED');
        break;
      }
      case '3_draft': {
        status = this.translateService.instant('STATUS_DRAFT');
        break;
      }
      case '3_folyamatban': {
        status = this.translateService.instant('IN_PROGRESS');
        break;
      }
      case '3_lezarva': {
        status = this.translateService.instant('CLOSED');
        break;
      }
      case '3_sztornozott': {
        status = this.translateService.instant('STATUS_CANCELLED');
        break;
      }
      default: {
        status = '-';
        break;
      }
    }
    return status;
  }

  isDeadlineOverdue(deadline: string | undefined){
    if(deadline === undefined) return false;
    const now = new Date();
    const deadlineDate = new Date(deadline);
    const timeDifference = deadlineDate.getTime() - now.getTime();
    return timeDifference <= 0;
  }

  getTimeLeft(deadline: string | undefined): string {
    if(deadline) {
      const currentTime = new Date();
      let deadlineTime: Date;

      if(this.isDetailsPage){
        if (deadline.includes(' ') && deadline.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/)) {
          const isoFormatted = deadline.replace(' ', 'T') + ':00';
          deadlineTime = new Date(isoFormatted);
          } else {
            return "";
          }
      } else {
        deadlineTime = new Date(deadline);
      }

      const timeDifference = deadlineTime.getTime() - currentTime.getTime();

      if (timeDifference <= 0) {
        return this.missedDeadline;
      }

      const minutes = Math.floor(timeDifference / (1000 * 60));
      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const years = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 365));

      if (years >= 1) {
        return years + ' ' + this.year;
      } else if (days >= 1) {
        return days + ' ' + this.day;
      } else if (hours >= 1) {
        return hours + ' ' + this.hour;
      } else {
        return minutes + ' ' + this.minute;
      }
    } else {
      return "";
    }
  }

  openDigraphDiagram(){
    //a digraph a workflow folyamat id-jával kérhető le, azt a referenceNumber tartalmazza
    const workflowId = Number(this.referenceNumber);
    if(workflowId){
      this.dmsWorkflowDigraph.openDiagram(workflowId, true);
    }
  }

}
